<template>
  <div id="container">

    <section id="register" style="min-height: auto;">
      <div class="wrap">

        <div class="cts_box">
          <h2 class="cts_ttl"><span>お支払い情報の変更を受け付けました</span></h2>
          <div class="thanks_lead">
            <p>
            </p>
          </div>
        </div>

        <div class="cts_box">
          <p class="alnC sp_alnL mb20">
          </p>
          <div class="button_wrap">
            <router-link :to="{ name: 'UsersCustomerAccount'}" class="submit basic arrow">マイページへ</router-link>
          </div>
        </div>
      </div><!--//.wrap-->
    </section>
  </div>
</template>

<script>
import Libraries from '@/components/Libraries.vue'

export default {
  mixins: [Libraries],
  data() {
    return {
    }
  }
}
</script>
